import {Space} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import {SubscriptionCoverImagesFormFieldsProps} from "./types";
import {OfferingCoverImagesUpload} from "../../general/cover-images";

export function SubscriptionCoverImagesFormFields({
  accordionIndex,
  defaultCoverImages,
  deleteCoverImage,
  isDeleteLoading,
  isUploadLoading,
  offeringId,
  uploadCoverImages,
}: SubscriptionCoverImagesFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      <OfferingCoverImagesUpload
        defaultCoverImages={defaultCoverImages}
        deleteCoverImage={deleteCoverImage}
        isDeleteLoading={isDeleteLoading}
        isUploadLoading={isUploadLoading}
        offeringId={offeringId}
        uploadCoverImages={uploadCoverImages}
        offeringType="subscription"
        uploadButtonText="Upload Image"
        uploadButtonIcon={<UploadOutlined />}
      />
    </Space>
  );
}
